module.exports = __webpack_public_path__ + "img/2-elite.ff1db5ef.png";